import apiClient from './api.service';

export interface MaterialReturnItem {
  id: string;
  item_id: string;
  returned_quantity: number;
  uom: string;
  unit_value: number;
  total_value: number;
  condition_status: 'Good' | 'Damaged' | 'Expired';
  notes?: string;
}

export interface MaterialReturn {
  id: string;
  return_number: string;
  company_id: string;
  work_order_id: string;
  material_issuance_id?: string;
  return_date: string;
  return_reason?: string;
  return_status: 'Pending' | 'Accepted' | 'Rejected';
  target_warehouse_id: string;
  department_id?: string | null;
  total_value: number;
  returned_by: string;
  accepted_by?: string;
  notes?: string;
  created_at: string;
  updated_at: string;
  items: MaterialReturnItem[];
  materialIssuance?: any;
}

export interface CreateMaterialReturnDTO {
  work_order_id: string;
  material_issuance_id?: string;
  target_warehouse_id: string;
  department_id?: string;
  return_reason?: string;
  notes?: string;
  items: Array<{
    item_id: string;
    returned_quantity: number;
    uom: string;
    unit_value?: number;
    condition_status?: 'Good' | 'Damaged' | 'Expired';
    notes?: string;
  }>;
}

class MaterialReturnService {
  async getAll(filters?: {
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<MaterialReturn[]> {
    try {
      const params = new URLSearchParams();
      if (filters?.status) params.append('status', filters.status);
      if (filters?.startDate) params.append('startDate', filters.startDate);
      if (filters?.endDate) params.append('endDate', filters.endDate);

      const response = await apiClient.get(`/inventory/material-returns?${params.toString()}`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching material returns:', error);
      return [];
    }
  }

  async getById(id: string): Promise<MaterialReturn> {
    const response = await apiClient.get(`/inventory/material-returns/${id}`);
    return response.data;
  }

  async getByWorkOrder(workOrderId: string): Promise<MaterialReturn[]> {
    try {
      const response = await apiClient.get(`/inventory/material-returns/work-order/${workOrderId}`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching material returns by work order:', error);
      return [];
    }
  }

  async create(data: CreateMaterialReturnDTO): Promise<MaterialReturn> {
    const response = await apiClient.post('/inventory/material-returns', data);
    return response.data;
  }

  async accept(id: string): Promise<MaterialReturn> {
    const response = await apiClient.post(`/inventory/material-returns/${id}/accept`);
    return response.data;
  }

  async reject(id: string, reason?: string): Promise<MaterialReturn> {
    const response = await apiClient.post(`/inventory/material-returns/${id}/reject`, { reason });
    return response.data;
  }
}

export const materialReturnService = new MaterialReturnService();
export default materialReturnService;
